import { render, staticRenderFns } from "./input-record.vue?vue&type=template&id=4e311f49"
import script from "./input-record.vue?vue&type=script&lang=js"
export * from "./input-record.vue?vue&type=script&lang=js"
import style0 from "./input-record.vue?vue&type=style&index=0&id=4e311f49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports